export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    typesThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrap" */'./ThemeImporter'),
  },
};
